import * as React from 'react';
import classnames from 'classnames';
import { CloseXSmall } from '@wix/wix-ui-icons-common/on-stage/system';
import { Text, TextTypography } from '../Text';
import { classes } from './Tag.st.css';
import { TagSize, TagSkin, TagProps } from './types';

export const Tag: React.FC<TagProps> = (props) => {
  const {
    skin,
    size,
    isRemovable,
    onClick,
    onRemove,
    removeButtonAriaLabel,
    children,
    className,
    tagName,
  } = props;

  const isClickable = !!(onRemove || onClick);
  const TagName = isClickable ? 'button' : tagName;

  return (
    <TagName
      className={classnames(
        classes.root,
        classes[skin],
        classes[size],
        className,
        {
          [classes.clickable]: isClickable,
          [classes.withIcon]: isRemovable,
        },
      )}
      onClick={isClickable ? handleClick : undefined}
      data-hook={props['data-hook']}
    >
      <div className={classes.opaque} />
      <Text className={classes.label} typography={TextTypography.listText}>
        {children}
      </Text>
      {isRemovable && (
        <span
          className={classes.iconWrapper}
          aria-label={removeButtonAriaLabel}
          data-hook="remove-icon"
        >
          <CloseXSmall className={classes.removeIcon} />
        </span>
      )}
    </TagName>
  );

  function handleClick(event) {
    if (isRemovable) {
      return onRemove(event);
    }

    return onClick ? onClick(event) : null;
  }
};

Tag.displayName = 'Tag';

Tag.defaultProps = {
  isRemovable: false,
  tagName: 'li',
  size: TagSize.medium,
  skin: TagSkin.solid,
};
